import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mapKeys } from 'lodash-es';
import type { Checkin } from '../../types';

type CheckinState = Record<number, Checkin>;

const initialState: CheckinState = {};

const checkinSlice = createSlice({
  name: 'checkin',
  initialState,
  reducers: {
    setCheckins(state, action: PayloadAction<Checkin[]>) {
      return mapKeys(action.payload, 'location') as unknown as CheckinState;
    },
    pushCheckin(state, action: PayloadAction<Checkin>) {
      state[action.payload.location] = action.payload;
    },
  },
});

export const { setCheckins, pushCheckin } = checkinSlice.actions;
export default checkinSlice.reducer;
